import { faSort } from '@fortawesome/pro-light-svg-icons/faSort';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';

import { ControlContainer, MenuPanel, OptionButton, PillButton } from './liveboard_control_styles';
import useCloseOnOutsideClick from './use_close_on_outside_click';

// Pill-styled single-select sort control that mirrors the Filter control:
// the opener shows the sort icon + the selected value, and clicking opens a
// list of sort options.
export default function LiveboardSortControl({ onChange, options, value }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  useCloseOnOutsideClick(
    containerRef,
    useCallback(() => setIsOpen(false), []),
    isOpen
  );

  const selected = options.find(option => option.value === value) || options[0];

  const select = optionValue => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <ControlContainer ref={containerRef}>
      <PillButton data-aid="agentsLiveboardSort-toggle" onClick={() => setIsOpen(open => !open)}>
        <FontAwesomeIcon icon={faSort} />
        {selected && selected.label}
      </PillButton>
      {isOpen && (
        <MenuPanel data-aid="agentsLiveboardSort-panel">
          {options.map(option => (
            <OptionButton
              data-aid={`agentsLiveboardSort-option-${option.value}`}
              key={option.value}
              onClick={() => select(option.value)}
              selected={option.value === value}
            >
              {option.label}
            </OptionButton>
          ))}
        </MenuPanel>
      )}
    </ControlContainer>
  );
}

LiveboardSortControl.propTypes = {
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string.isRequired,
};
